// Import dependencies
import { AutomatorTemplateItem } from '../_base';
import { unsafeCSS, css } from 'lit';
import { customElement } from 'lit/decorators.js';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-template-item-trigger' )
export class AutomatorTemplateTrigger extends AutomatorTemplateItem {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;
}
